/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
 // document.addEventListener('theme:cart:init', (e) => {
 //   console.log('theme:cart:init');
 //   console.log(e);
//  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
 // document.addEventListener('theme:scroll', e => { console.log(e); });
//  document.addEventListener('theme:scroll:up', e => { console.log(e); });
 // document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
 // document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();

jQuery(".tab-link").on("click",function(){
  var tab = jQuery(this).attr("data-tab");
  jQuery(this).addClass("current");
  jQuery(this).siblings().removeClass("current");
  jQuery(".tab-content-"+tab).addClass("current");
  jQuery(".tab-content-"+tab).siblings().removeClass("current");
  
});

jQuery(".search__predictive__close__inner").on("click",function(){
  jQuery("#search-popdown").removeClass("is-visible");
});

// // Get the element to observe
// var targetElement = document.getElementById('search-popdown');

// // Create a mutation observer instance
// var observer = new MutationObserver(function(mutationsList, observer) {
//     mutationsList.forEach(function(mutation) {
//         console.log('DOM change detected:', mutation);
//         var firstResult = jQuery('.search__results__products__list .product__inline:first-of-type');
//         var firstResultUrl = firstResult.attr('href');
//         if(firstResultUrl.indexOf('rolex') > -1){
//           console.log('firstResultUrl', firstResultUrl);
//         }
//         // You can add custom logic to handle the mutation here
//     });
// });

// // Define what types of mutations to observe
// var config = {
//     childList: true, // Detect addition/removal of child elements
//     attributes: true, // Detect changes to attributes
//     subtree: true, // Monitor all descendants of the target
//     characterData: true // Detect changes to text within the element
// };

// // Start observing the target element
// observer.observe(targetElement, config);


jQuery('input[name="q"]').on('keyup change', function(){
  var searchTerm = jQuery(this).val();
  //Rolex search redirect
  var searchTermLowercase = searchTerm.toLowerCase();
  window.redirects.some(function (redirect) {
    var terms = redirect.search_terms.split('\n');
    var match = terms.some(function (term) {
      return searchTermLowercase.indexOf(term.toLowerCase().trim()) > -1;
    });

    match && window.location.assign(redirect.url);
    return match;
  });
});

jQuery("[data-popdown-toggle='search-popdown']").on("click",function(e){
  e.preventDefault();
  jQuery("#search-popdown").addClass("is-visible");
});